import { AnimatePresence } from 'framer-motion'
import { memo } from 'react'
import { Routes, Route } from 'react-router-dom'

import { Layout } from '@widgets/layout'

import { UserRouter } from './_routers/userRouter'
import { ErrorPage } from './_system'
import MainPage from './main'

const Routing = ({ onLogout }) => {
  return (
    <AnimatePresence>
      <Routes>
        <Route path="/" element={<Layout onLogout={onLogout} />}>
          <Route index element={<MainPage />} />

          <Route path="*" element={<UserRouter />} />
        </Route>

        <Route path="error" element={<ErrorPage />} />
      </Routes>
    </AnimatePresence>
  )
}

export default memo(Routing)
